import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, legalHead } from "@/components/LegalPage";

export const Route = createFileRoute("/company-info")({
  head: () =>
    legalHead({
      title: "Company Information | Preserve Earth",
      description:
        "Registered company details for Preserve Earth, a trading name of RBM London Limited: registered office, company number, ICO registration and VAT number.",
      path: "/company-info",
      crumbName: "Company Information",
    }),
  component: CompanyInfoPage,
});

const rows: [string, string][] = [
  ["Trading name", "Preserve Earth"],
  ["Registered company", "RBM London Limited"],
  [
    "Registered office",
    "167-169 Great Portland Street, 5th Floor, London, W1W 5PF",
  ],
  ["Registered in", "England & Wales"],
  ["Company No.", "15482817"],
  ["ICO Registration No.", "ZB660487"],
  ["VAT No.", "GB 460 8223 05"],
  ["Contact", "info@preserveearth.co.uk"],
];

function CompanyInfoPage() {
  return (
    <LegalPage
      crumb={{ name: "Company Information", path: "/company-info" }}
      eyebrow="Company information"
      title="Company information."
      intro={
        <p>
          Preserve Earth is a trading name of RBM London Limited, registered in
          England &amp; Wales. Our registered details are set out below.
        </p>
      }
    >
      <dl className="mt-10 grid max-w-3xl gap-px border border-charcoal/10 bg-charcoal/10">
        {rows.map(([label, value]) => (
          <div
            key={label}
            className="flex flex-col gap-1 bg-cream px-6 py-5 sm:flex-row sm:items-baseline sm:gap-8"
          >
            <dt className="text-xs font-medium uppercase tracking-[0.2em] text-moss sm:w-56 sm:shrink-0">
              {label}
            </dt>
            <dd className="text-charcoal/80">
              {label === "Contact" ? (
                <a
                  href="mailto:info@preserveearth.co.uk"
                  className="underline decoration-moss/30 underline-offset-4 hover:decoration-moss"
                >
                  {value}
                </a>
              ) : (
                value
              )}
            </dd>
          </div>
        ))}
      </dl>
    </LegalPage>
  );
}
